const FooterCopyright = () => {
    return (
        <div className="text-center p-3" id="copyright_div">
        © 2022 Copyright: Indian Steel Association
         {/* Designed & Developed by &nbsp;
        <a
          className="text-white"
          href="https://confianzamedia.com/"
          target="_blank"
          rel="noreferrer"
        >
          Confianza Media
        </a> */}
      </div>
    )
}

export default FooterCopyright;